import {
  ProfileCareerAttachFileSaveVO,
  ProfilePortfolioAttachFileSaveVO,
} from '@domain/rq/profile/ProfileAttachFileSaveRq';

export class ProfileFileFormVO {
  portfolioAttachFiles: ProfilePortfolioAttachFileSaveVO[];
  careerAttachFiles: ProfileCareerAttachFileSaveVO[];
  referenceUrls: string[];

  constructor(vo: ProfileFileFormVO) {
    this.portfolioAttachFiles = vo.portfolioAttachFiles;
    this.careerAttachFiles = vo.careerAttachFiles;
    this.referenceUrls = vo.referenceUrls.length > 0 ? vo.referenceUrls : [''];
  }
}
